import React from 'react';
import { useTheme } from '@/context/ThemeContext';

interface PropertyShieldLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const PropertyShieldLogo: React.FC<PropertyShieldLogoProps> = ({ 
  className = '',
  size = 'md'
}) => {
  const { theme } = useTheme();
  
  const sizeClasses = {
    sm: 'h-5 w-auto',
    md: 'h-7 w-auto',
    lg: 'h-10 w-auto'
  };

  // In dark mode, use the original logo
  if (theme === 'dark') {
    return (
      <img
        src="/lovable-uploads/1914b580-f531-4bbb-b482-12c359596bae.png"
        alt="PropertyShield AI"
        className={`${sizeClasses[size]} ${className}`}
      />
    );
  }

  // Light mode: Text-based logo with brand colors
  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <div className="flex items-center">
        <span className={`font-bold text-foreground ${size === 'sm' ? 'text-sm' : size === 'lg' ? 'text-xl' : 'text-base'}`}>
          Property
        </span>
        <span className={`font-bold text-primary ${size === 'sm' ? 'text-sm' : size === 'lg' ? 'text-xl' : 'text-base'}`}>
          Shield
        </span>
        <span className={`font-medium text-muted-foreground ml-1 ${size === 'sm' ? 'text-xs' : size === 'lg' ? 'text-base' : 'text-sm'}`}>
          AI
        </span>
      </div>
    </div>
  );
};

export default PropertyShieldLogo;
